import React, { type FC } from 'react';

import { Avatar } from '@shared/ui/avatar';
import IconGroupDefault from '@assets/img/group-ava.svg';

import type { ContactItemProps } from './types';

import styles from './styles.module.scss';

/**
 * Компонент Contact отображает информацию о пользователе или группе, включая аватар, имя и дополнительное описание.
 */
export const ContactItem: FC<ContactItemProps> = ({
	avatar,
	infoDescription,
	isCompact = false,
	isGroup = false,
	rightAddons,
	name,
	status,
}) => (
	<div className={styles.Container}>
		<Avatar
			fallbackSvg={isGroup ? IconGroupDefault : undefined}
			image={avatar}
			name={name}
			status={isGroup ? undefined : status}
		/>

		{!isCompact && (
			<>
				<div className={styles.InfoContainer}>
					<div className={styles.TitleContainer}>
						<span className={styles.Title}>{name}</span>
					</div>

					{infoDescription && <div className={styles.Info}>{infoDescription}</div>}
				</div>

				{rightAddons}
			</>
		)}
	</div>
);
